/* 🤖 this file was generated by svg-to-ts */
export const matIconAirlineSeatReclineNormal: {
  name: 'airline-seat-recline-normal';
  data: string;
} = {
  name: 'airline-seat-recline-normal',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.59 5.41c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0 .78 2.05 0 2.83c-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"/></svg>`
};
